module.exports = new __parcel__URL__("customer.cefb20c0.html").toString();